import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface PassedProps {
  leftHanded?: boolean;
}

export const styles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  instructionTypography: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.35),
    fontWeight: 500,
    letterSpacing: 0.5,
    color: themeColor.defaultTextColor,
    fontStyle: 'normal',
    height: '3.12vh',
    marginTop: '1.9vh',
    marginBottom: '1.9vh',
  },
  nonDenomTenderCountContainer: {
    padding: `.75vh 1.3vw`,
  },
  keypadContainer: {
    height: 'fit-content',
    alignSelf: 'flex-end',
  },
  keypad: {
    alignContent: (props: PassedProps) => (props.leftHanded ? 'flex-start' : 'flex-end'),
  },
  tenderListHeader: {
    color: theme.palette.info.main,
    fontWeight: 500,
    lineHeight: 1.13,
    fontSize: vh(2.08),
    padding: `.75vh 0`,
  },
  tenderListContainer: {
    backgroundColor: themeColor.white,
    marginBottom: 10,
    flexGrow: 1,
  },
  subTotalTypography: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.35),
    fontWeight: 500,
    letterSpacing: 0.5,
    color: themeColor.defaultTextColor,
    fontStyle: 'normal',
    padding: '1.3vh 0',
  },
  subTotalLabelTypography: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.35),
    fontWeight: 500,
    letterSpacing: 0.5,
    color: theme.palette.info.main,
    fontStyle: 'normal',
    padding: '1.3vh 0',
  },
  tenderLineItemActionContainer: {
    justifyContent: 'flex-end',
  },
  paginationContainer: {
    width: '60%',
  },
  okButton: {
    fontSize: rem(1),
    marginLeft: '.75vw',
    '@media (max-width: 800px)': {
      fontSize: rem(0.875),
      marginLeft: '.5vw',
    },
  },
  tenderListButtonContainer: {
    textAlign: 'end',
  },
  denomTypeContainer: {
    marginBottom: '10px',
    justifyContent: 'center',
  },
  scrollButton: {
    width: '4.09vw',
    '&:first-of-type': {
      marginLeft: '2.19vw',
    },
  },
  tab: {
    minWidth: '11.34vw',
    '& span': {
      fontSize: '1.95vh',
      letterSpacing: '.5px',
      lineHeight: '16px',
      color: theme.palette.info.dark,
      '& svg': {
        color: theme.palette.info.main,
        fill: theme.palette.info.main,
        fontSize: '2.86vh',
      },
    },
    '&.Mui-selected': {
      '& span': {
        color: themeColor.blackpearl,
        '& svg': {
          color: theme.palette.secondary.main,
          fill: theme.palette.secondary.main,
        },
      },
    },
    '& svg': {
      width: '2.86vh',
      height: '2.86vh',
    },
  },
  denominationButtonContainer: {
    width: '100%',
    backgroundColor: themeColor.lightBackground,
    alignContent: 'flex-start',
  },
  denominationButton: {
    lineHeight: 1.01,
    letterSpacing: 0.5,
    marginBottom: '10px',
    marginRight: '20px',
    justifyContent: 'flex-start',
    padding: `0 1.5vw`,
    fontSize: vh(2.23),
    width: '15.63vw',
    '@media (max-height: 768px)': {
      fontSize: '2vh',
    },
    '@media (max-width: 912px)': {
      width: '12vw',
      padding: '0 0',
    },
  },
  denominationButtonSelected: {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
  buttonStartIcon: {
    marginLeft: '0.58vw',
    marginRight: '0.58vw',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      height: '30px',
      maxHeight: '2.6vh',
    },
  },
}));
